import { ROUTER } from "~/common/router"

const spmStorageKey = "kada-video-spm"

const pathnameSpmMap: Readonly<Record<string, string>> = {
  [ROUTER.DOUDIAN_CALL_BACK]: "doudian",
  [ROUTER.DOUYIN_CALL_BACK]: "douyin",
}

let cachedSpm = ""

const normalizeSpm = (value?: string | null) => {
  const spm = value?.trim()

  if (!spm) return ""

  return spm.toLowerCase().replace(/[^a-z0-9_-]/g, "")
}

const getLocationSpm = () => {
  const searchSpm = normalizeSpm(
    new URLSearchParams(window.location.search).get("spm"),
  )

  return searchSpm || pathnameSpmMap[window.location.pathname] || ""
}

const setStoredSpm = (spm: string) => {
  const normalizedSpm = normalizeSpm(spm)

  if (!normalizedSpm) return ""

  cachedSpm = normalizedSpm

  try {
    window.sessionStorage.setItem(spmStorageKey, normalizedSpm)
  } catch {
    // sessionStorage can be unavailable in restricted browser contexts.
  }

  return normalizedSpm
}

export const getStoredSpm = () => {
  try {
    return (
      normalizeSpm(window.sessionStorage.getItem(spmStorageKey)) || cachedSpm
    )
  } catch {
    return cachedSpm
  }
}

export const captureEntrySpm = () => {
  const spm = getLocationSpm()

  if (!spm) return null
  setStoredSpm(spm)
}
